import { type Chain } from "viem";

import config from "configs/app";

const currentChain = {
  id: Number(config.chain.id),
  name: config.chain.name ?? "",
  nativeCurrency: {
    decimals: config.chain.currency.decimals,
    name: config.chain.currency.name ?? "",
    symbol: config.chain.currency.symbol ?? "",
  },
  rpcUrls: {
    default: {
      http: [config.chain.rpcUrls?.[0] ?? ""],
    },
  },
  blockExplorers: {
    default: {
      name: config.chain.name || "",
      url: config.app.baseUrl,
    },
  },
  testnet: config.chain.isTestnet,
} as const satisfies Chain;

export const currentL1Chain = {
  id: Number(config.l1Chain.id),
  name: config.l1Chain.name ?? "",
  nativeCurrency: {
    decimals: config.l1Chain.currency.decimals,
    name: config.l1Chain.currency.name ?? "",
    symbol: config.l1Chain.currency.symbol ?? "",
  },
  rpcUrls: {
    default: {
      http: [config.l1Chain.rpcUrl ?? ""],
    },
  },
  blockExplorers: {
    default: {
      name: config.l1Chain.name || "",
      url: config.l1Chain.explorerUrl || "",
    },
  },
  testnet: config.l1Chain.isTestnet,
} as const satisfies Chain;

export default currentChain;
